<template>
	<div
	class="switch-wrapper"
	:class="[{'active': isActive, 'disabled': disabled}]"
	@click.stop="[emit('clicked', !isActive), animationStateCss = '--animation-state: running']">
		<div class="switch-bar">
			<icon-list v-if="!isActive"/>
			<app-icon v-else-if="isActive"/>
		</div>
		<div class="switch-ball" :style="animationStateCss">
			<app-icon v-if="!isActive"/>
            <icon-list v-else-if="isActive"/>
        </div>
	</div>
</template>

<script setup>
// import IconCarousel from '@/assets/icons/carousel.svg?inline'
// import IconList from '@/assets/icons/pin-drop.svg?inline'
import IconList from '@/assets/icons/list.svg?inline'

/* Vue */
import { ref, computed, defineAsyncComponent } from 'vue'

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@isActive {Boolean} - prop to trigger isActive styles
@disabled {Boolean} - prop to apply disabled styles
@mapIcon {Boolean} - prop to apply pin icon
*/
const props = defineProps({
	isActive: Boolean,
	disabled: Boolean,
	mapIcon: Boolean
})

/* Animation rotation for icon is initially paused (to not make the initial animation)
After clicked on switch is running */
const animationStateCss = ref('--animation-state: paused')

const appIcon = computed(() => {
    const icon = props.mapIcon ? 'pin-drop' : 'carousel'
	return defineAsyncComponent(() => import('@/assets/icons/' + icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.switch-wrapper {
	width: 80px;
	height: 40px;
	position: relative;
	cursor: pointer;

	.switch-bar {
		width: 80px;
		height: 40px;

		display: flex;
		align-items: center;

		border-radius: 24px;
		background-color: var(--secondary-light-4);
		transition: all 0.2s ease-in-out;
        border: 1px solid var(--secondary-light-1);

		svg {
			width: 16px;
            height: 16px;
            flex-shrink: 0;

			position: absolute;
			right: 16px;

			:deep(.change-color-fill) {
				fill: var(--secondary-dark-3);
			}
		}
	}

	.switch-ball {
		width: 32px;
		height: 32px;
		top: 4px;
		left: 4px;
		position: absolute;
		border-radius: 50%;
		transition: all 0.2s ease-in-out;
		overflow: hidden;

		background-color: var(--primary);

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        svg {
            width: 16px;
            height: 16px;
            flex-shrink: 0;

			animation: fade-scale 0.6s ease-in-out;
			animation-play-state: var(--animation-state);

            :deep(.change-color-fill) {
                fill: var(--secondary-light-4);
            }
        }
	}

	&.active {
		.switch-bar {
			background-color: var(--secondary-light-4);

			svg {
				left: 16px;
			}
		}

		.switch-ball {
			left: calc(64px - 22px);
			background-color: var(--primary);
		}
	}

	&.disabled {
		pointer-events: none;
		cursor: default;
	}
}

@keyframes fade-scale {
	0.1% {
		transform: scale(0);
	}
	100% {
		transform: scale(1);
	}
}
</style>
